module.exports = __webpack_public_path__ + "static/img/USC_Marshall_CurriculumMap_2023_BCA_R3.17be5c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/USC_Marshall_CurriculumMap_2023_BCA_R3.png
// module id = YrMk
// module chunks = 1